import { Component, ViewChild, OnInit, Input, Output, EventEmitter, ComponentFactoryResolver, AfterViewInit, AfterContentInit } from '@angular/core';
import { Widget,Dashboard } from 'src/api/models';
import { ActivatedRoute, Params, Router } from '@angular/router';

import { DashboardTableService } from 'src/service/dashboard.service';
import { DashboardService } from 'src/api/services/dashboard.service';
import { WidgetService } from 'src/service/widget.service';
import { IWidget, WidgetType, DashboardSelection, WidgetSelection } from 'src/app/models/dashboard';
import { WidgetDirective } from '../../directives/widget.directive';

@Component({
  selector: 'app-widget',
  templateUrl: './widget.component.html',
  styleUrls: ['./widget.component.css']
})

export class WidgetComponent implements AfterViewInit, AfterContentInit, OnInit {
  @ViewChild(WidgetDirective) host: WidgetDirective;
  @Input() widget: Widget;
  @Input() dashboard: Dashboard;
  @Input() siteUri: string;
  @Input() uri: string;
  @Input() fullScreen: boolean = false;
  @Input() delayLoad: boolean = false;
  @Input() isEditing: boolean = false;
  public data: any; // for passing of any state to the widget

  public loading: boolean = false;

  @Output() dashboardSelected = new EventEmitter<DashboardSelection>();
  //@Output() widgetSelected = new EventEmitter<WidgetSelection>();
 
  widgets: Array<WidgetType>;
  
  constructor(private componentFactoryResolver: ComponentFactoryResolver, 
    private widgetService: WidgetService,
    private service: DashboardTableService,
    private dashboardService: DashboardService,
    private route: ActivatedRoute) {}

  ngOnInit() {
    this.widgets = this.widgetService.getWidgets();
  }

  public clear(){
    this.widget = null;
  }

  public reload(widgetSelection:WidgetSelection){
    this.widget = widgetSelection.widget;
    this.data = widgetSelection.data;
    (<IWidget>this.componentRef.instance).state = this.data;
  }

  ngAfterViewInit(): void {
    if (this.widget == null) {
      this.route.params.subscribe(params => {
        const dashboardId = params["dashboardId"];
        const widgetId = parseInt(params["widgetId"]);
        this.uri = params["uri"];
        this.getDashboardById(dashboardId, widgetId);
      });
    }
    else {
      this.loadComponent();
    }
  }

  ngAfterContentInit(): void {
    
  }

  getDashboardById(id: string, widgetId: number): void {
    this.service.getDashboard(id, false) //todo: what should this be?
      .subscribe(
        res => {
          if (res) {
            this.dashboard = res;
            for (var c of res.columns){
              for (var w of c.widgets){
                if (w.widgetId == widgetId) {
                  this.widget = w;
                  continue;
                }
              }
            }
            this.loadComponent();
          }
        },
        err => {
          console.error("ERROR: getDashboardById", err);
        }
      )
  }

  componentRef:any;

  loadComponent() {
    // Load Component
    
    let component = this.getComponent(this.widget.type)
    if (component){
      let componentFactory = this.componentFactoryResolver.resolveComponentFactory(component);

      let viewContainerRef = this.host.viewContainerRef;
      viewContainerRef.clear();

      this.componentRef = viewContainerRef.createComponent(componentFactory);
      (<IWidget>this.componentRef.instance).widget = this.widget;
      (<IWidget>this.componentRef.instance).dashboard = this.dashboard;
      (<IWidget>this.componentRef.instance).uri = this.siteUri;
      (<IWidget>this.componentRef.instance).widgetComponent = this;
      (<IWidget>this.componentRef.instance).dashboardSelected = this.dashboardSelected;
      //(<IWidget>this.componentRef.instance).widgetSelected = this.widgetSelected;

      (<IWidget>this.componentRef.instance).loadComplete(true);    
    } else {
      console.warn("Widget not found:" + this.widget.type);
    }
  }

  getComponent(name: string): any /*Type<IWidget>*/ {
    var widget = this.widgets.find(w => w.type == name);
    if (widget) return  widget.component;
    return null;
  }

  public loadData(){
    if (this.componentRef && this.componentRef.instance && this.componentRef.instance.loadData){
      this.componentRef.instance.loadData();
    }
  }
}
